export default{
    showLoading(state){ 
        return state.showLoading  
    }
}


// WEBPACK FOOTER //
// ./src/store/getters.js